import { CommonBaseData } from "../../data";

export class LeftMainData extends CommonBaseData {
  public pgmId: string;
  public daikouFlg: string; // ST-162
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/left/left-main-data.ts